import Handlebars from 'handlebars';

export default Handlebars.compile(`
{{#each this}}
<option value="0">{{this}}</option>
{{/each}}
`);
